import React, { createContext, useContext, ReactNode } from "react";
import { useWhatsNew, UseWhatsNew } from "./useWhatsNew";

const WhatsNewContext = createContext<UseWhatsNew | undefined>(undefined);

/**
 * Provides a single shared "What's New" feed to the whole authenticated app
 * (dashboard strip + card pills, sidebar bell, per-section sidebar dots) so the
 * endpoint is only hit once per session.
 */
export const WhatsNewProvider = ({ children }: { children: ReactNode }) => {
  const value = useWhatsNew(30);
  return (
    <WhatsNewContext.Provider value={value}>
      {children}
    </WhatsNewContext.Provider>
  );
};

export const useWhatsNewContext = (): UseWhatsNew => {
  const ctx = useContext(WhatsNewContext);
  if (!ctx) {
    throw new Error("useWhatsNewContext must be used within a WhatsNewProvider");
  }
  return ctx;
};
